export const normalizePhoneNumber = (rawPhone: string, countryPrefix?: string | null): string => {
  const trimmed = rawPhone.trim();
  if (!trimmed) {
    return "";
  }

  const digitsOnly = trimmed.replace(/\D/g, "");

  if (trimmed.startsWith("+")) {
    return digitsOnly ? `+${digitsOnly}` : "";
  }

  if (trimmed.startsWith("00")) {
    const withoutInternationalPrefix = digitsOnly.slice(2);
    return withoutInternationalPrefix ? `+${withoutInternationalPrefix}` : "";
  }

  if (countryPrefix) {
    const cleanedPrefix = countryPrefix.replace(/\D/g, "");
    return cleanedPrefix && digitsOnly ? `+${cleanedPrefix}${digitsOnly}` : digitsOnly;
  }

  return digitsOnly;
};

/**
 * Auth0 masks phone numbers on MFA screens with literal X characters
 * ("XXXXXXX3843"); the Thon designs use asterisks. Only the mask characters are
 * rewritten - digits, spaces and any dial code are left exactly as they came.
 */
export const maskPhoneWithAsterisks = (maskedPhone: string): string =>
  maskedPhone.replace(/x/gi, "*");
